// "Second item" offer in the cart drawer: the add buttons put the product in the cart and
// re-render the drawer the same way the product form does.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cart-upsell-add]');
  if (!button) return;

  const cartDrawer = document.querySelector('cart-drawer');
  button.setAttribute('aria-disabled', 'true');
  button.classList.add('loading');

  fetch(`${routes.cart_add_url}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [{ id: Number(button.dataset.cartUpsellAdd), quantity: 1 }],
      sections: cartDrawer ? cartDrawer.getSectionsToRender().map((section) => section.id) : [],
      sections_url: window.location.pathname,
    }),
  })
    .then((response) => response.json())
    .then((state) => {
      if (state.status) throw new Error(state.description || state.message);
      if (cartDrawer) {
        cartDrawer.renderContents(state);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: state });
      } else {
        window.location = window.routes.cart_url;
      }
    })
    .catch((error) => {
      console.error(error);
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
    });
});
